import { getTimeIndex } from "src/components/DeviceSettingsDialog/NoiseThresholds/formatTimeRange"

/** Transform string into array holding lower & upper values for slider */
export function translateSliderValue(value: string): [number, number] {
  const [s1 = "", s2 = ""] = value.split("-")
  const v1 = getTimeIndex(s1.trim())
  const v2 = getTimeIndex(s2.trim())
  return [v1, v2]
}
